var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMyGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-my-gallery",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 121.73,
    height: 96.135,
    viewBox: "0 0 121.73 96.135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 121.73,
    height: 96.135,
    fill: "#1152e4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M102.151,0H19.579A19.6,19.6,0,0,0,0,19.579V76.556A19.6,19.6,0,0,0,19.579,96.135h82.572A19.6,19.6,0,0,0,121.73,76.556V19.579A19.6,19.6,0,0,0,102.151,0M19.579,6.383h82.572a13.212,13.212,0,0,1,13.2,13.2V55.568l-5.106-4.607a11.061,11.061,0,0,0-14.813-.032L80.415,64.363a4.688,4.688,0,0,1-6.5-.225L46.934,36.414a11.064,11.064,0,0,0-14.773-1L6.383,55.6V19.579a13.212,13.212,0,0,1,13.2-13.2m82.572,83.37H19.579a13.212,13.212,0,0,1-13.2-13.2V63.711L36.1,40.444a4.691,4.691,0,0,1,6.264.422L69.341,68.59a11.055,11.055,0,0,0,15.33.529L99.685,55.685a4.69,4.69,0,0,1,6.28.014l8.729,7.877a3.169,3.169,0,0,0,.653.452V76.556a13.212,13.212,0,0,1-13.2,13.2",
    fill: "#1152e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M169.039,69.056a13.088,13.088,0,1,0-13.088-13.088,13.1,13.1,0,0,0,13.088,13.088m0-19.794a6.705,6.705,0,1,1-6.706,6.705,6.713,6.713,0,0,1,6.706-6.705",
    transform: "translate(-89.594 -24.634)",
    fill: "#1152e4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyGallery);
export default __webpack_public_path__ + "static/media/icon-my-gallery.82ed0a8de485ce3f4ae35f52952ee5e2.svg";
export { ForwardRef as ReactComponent };